import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import AppShell from './components/AppShell';
import Home from './components/Home';
import SignIn from './components/SignIn';
import Dashboard from './components/Dashboard';
import ApplicationsPage from './components/ApplicationsPage';
import ProgramsPage from './components/ProgramsPage';
import LawsPage from './components/LawsPage';
import DecisionsPage from './components/DecisionsPage';
import ReviewRounds from './components/ReviewRounds';
import SetCriteriaScore from './components/SetCriteriaScore';
import DatFileImport from './components/DatFileImport';
import UserManagementPage from './components/UserManagementPage';
import ProtectedRoute from './components/ProtectedRoute';
import NewApplication from './components/NewApplication';
import DocumentUpload from './components/DocumentUpload';
import ProjectInfo from './components/ProjectInfo';
import BudgetForm from './components/BudgetForm';
import DOLDetermination from './components/DOLDetermination';
import ApplicationDetail from './components/ApplicationDetail';
import './themes.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/" element={<Home />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['Super Admin', 'Grant Manager', 'Internal Reviewer']}>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="applications" element={<ApplicationsPage />} />
          <Route path="applications/:id" element={<ApplicationDetail />} />
          <Route path="application/:id" element={<Navigate to="/dashboard/applications" replace />} />
          <Route path="programs" element={<ProgramsPage />} />
          <Route path="laws" element={<LawsPage />} />
          <Route path="review-rounds" element={<ReviewRounds />} />
          <Route path="set-review-rounds" element={<Navigate to="/dashboard/review-rounds" replace />} />
          <Route path="set-criteria" element={<SetCriteriaScore />} />
          <Route path="decisions" element={<DecisionsPage />} />
          <Route
            path="users"
            element={
              <ProtectedRoute allowedRoles={['Super Admin']}>
                <UserManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="data-files"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Grant Manager']}>
                <DatFileImport />
              </ProtectedRoute>
            }
          />
          <Route
            path="new-application/documents"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Grant Manager']}>
                <DocumentUpload />
              </ProtectedRoute>
            }
          />
          <Route
            path="new-application"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Grant Manager']}>
                <NewApplication />
              </ProtectedRoute>
            }
          />
          <Route
            path="new-application/project"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Grant Manager']}>
                <ProjectInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path="new-application/budget"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Grant Manager']}>
                <BudgetForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="new-application/dol"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Grant Manager']}>
                <DOLDetermination />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="/applications" element={<Navigate to="/dashboard/applications" replace />} />
        <Route path="/programs" element={<Navigate to="/dashboard/programs" replace />} />
        <Route path="/laws" element={<Navigate to="/dashboard/laws" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
